import React, { useState } from 'react';
import './style.css'; // Your custom CSS file
import Button from '../CtaButton';

const LifeAtBitsclanTabs = () => {
    const [activeTab, setActiveTab] = useState('mission');

    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
    };

    const lifeAtTabsData = [
        {
            id: "vision-mission",
            title: "Our Mission & Vision",
            heading: "Vision & Mission",
            description:
                "At Bitsclan IT Solutions, we empower businesses with innovative technology that drives measurable growth & lasting value. We envision a future where organizations embrace digital transformation with confidence, using secure & intelligent solutions to stay ahead in the digital-first economy. <br/> <br/> Through AI-powered platforms, enterprise software, cloud services, & expert consulting, we help companies optimize operations, embrace change, & unlock their full potential. Our goal is to be the most trusted global partner for digital transformation, shaping industries, empowering enterprises, & redefining what technology can achieve.",
            image: "/images/life-at-bitsclan/about-us.avif",
        },
        {
            id: "vision",
            title: "Our Vision",
            heading: "Vision",
            description:
                "Our vision is to be recognized as the most trusted global partner for digital transformation. We aspire to shape the future of industries by delivering scalable, secure, & intelligent technologies that enable businesses to innovate with confidence, embrace disruption, & lead in their markets. Guided by integrity, innovation, & excellence, we envision a world where technology empowers every business to achieve its full potential.",
            image: "/images/life-at-bitsclan/life-image-2.avif",
        },
        // 👉 Add more tabs here
    ];


    return (
        <div className="life-at-bitscaln-tabs">
            <div className="container">
                {/* <div className="row">
                    <div className="col-md-12">
                        <ul className="nav nav-pills life-at-bitscaln-tabs-nav" role="tablist">
                            {lifeAtTabsData.map((tab) => (
                                <li key={tab.id} className="nav-item">
                                    <a
                                        className={`nav-link life-at-bitscaln-tabs-nav-item ${activeTab === tab.id ? "active" : ""
                                            }`}
                                        onClick={() => handleTabClick(tab.id)}
                                        role="tab"
                                        aria-selected={activeTab === tab.id}
                                    >
                                        {tab.title}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="col-md-12">
                        <div className="life-at-bitscaln-tabs-content">
                            {lifeAtTabsData.map(
                                (tab) =>
                                    activeTab === tab.id && (
                                        <div key={tab.id} className="tab-pane show active" role="tabpanel">
                                            <div className="d-flex align-items-start life-at-bitscaln-tabs-container">
                                                <div className="me-4 life-at-bitscaln-tabs-image">
                                                    <img src={tab.image} alt={tab.heading} />
                                                </div>
                                                <div className="life-at-bitscaln-tabs-text">
                                                    <h3 className="h4">{tab.heading}</h3>
                                                    <p>{tab.description}</p>
                                                    <Button text="Let’s Build the Future Together" link="/contact-us" />
                                                </div>
                                            </div>
                                        </div>
                                    )
                            )}
                        </div>
                    </div>
                </div> */}

                <div className="row align-items-center">
                    <div className="col-xl-6 col-lg-6 col-md-5 col-sm-12">
                        <div className="life-at-bitscaln-tabs-image">
                            <img src={lifeAtTabsData[0].image} />
                        </div>
                    </div>

                    <div className="col-xl-6 col-lg-6 col-md-7 col-sm-12">
                        <div className="life-at-bitscaln-tabs-text">
                            <h3 className="mt-0">{lifeAtTabsData[0].title}</h3>
                            <p dangerouslySetInnerHTML={{ __html: lifeAtTabsData[0].description }}></p>
                            <Button text="Let’s Build the Future Together" link="/contact-us" />
                        </div>
                    </div>
                </div>
                {/* 
                <div className="row mt-5">
                    <div className="col-md-6">
                        <div className="life-at-bitscaln-tabs-text">
                            <h3 className="h4">{lifeAtTabsData[1].title}</h3>
                            <p>{lifeAtTabsData[1].description}</p>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="life-at-bitscaln-tabs-image">
                            <img src={lifeAtTabsData[1].image} />
                        </div>
                    </div>
                </div> */}

                {/* <div className="row mt-5">
                    <div className="col-md-12 d-flex justify-content-center">
                        <Button text="Let’s Build the Future Together" link="/contact-us" />
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default LifeAtBitsclanTabs;